import {useEffect, useState} from 'react';
import {useAuthStore} from '../../store/authStore';
import LoginForm from '../organs/shared/loginForm';

type AuthenticationProviderProps = {
    children: JSX.Element;
};

const AuthenticationProvider = ({children}: AuthenticationProviderProps) => {
    const matches = window.location.href.match(
        /\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/?.*?[&?]postcode=([^&]+).*?$/
    );
    const [attemptAutoLogin, setAttemptAutoLogin] = useState(
        matches !== null && matches.length === 3
    );
    const {isAuthenticated, setEmailAndOrderBearer, setUuidAndPostcodeBearer} =
        useAuthStore(state => state);

    useEffect(() => {
        if (!attemptAutoLogin || matches === null) {
            return;
        }

        const postcode = matches[2];
        const uuid = matches[1];
        setUuidAndPostcodeBearer(uuid, postcode);
        setAttemptAutoLogin(false);
    }, [attemptAutoLogin]); // eslint-disable-line react-hooks/exhaustive-deps

    if (!attemptAutoLogin && !isAuthenticated) {
        return (
            <LoginForm
                headerText={'Alles over je bestelling, zo geregeld!'}
                handleSubmit={async (orderNumber, email) => {
                    setEmailAndOrderBearer(email, orderNumber);
                    return Promise.resolve();
                }}
            />
        );
    }

    console.log('render authenticated', attemptAutoLogin, isAuthenticated);

    return children;
};

export default AuthenticationProvider;
